export default "__VITE_ASSET__78520707__"